import { createFileRoute } from '@tanstack/react-router'
import { ScMailboxSettingsPage } from '@/features/support-coordination/mailbox-settings'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/mailbox-settings',
)({
  component: ScMailboxSettingsPage,
})
